import React from "react";
import PropTypes from "prop-types";
import { isZh } from "../utils/language";

export default function FileInfoDialog({ file, onClose, showShareActions = false }) {
  if (!file) return null;

function formatSize(bytes) {
  if (!bytes) return "-";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function buildBreadcrumb(folder) {
  if (!folder) return [];
  const trail = [];
  let current = folder;
  while (current) {
    trail.unshift(current);
    current = current.document_folder || null;
  }
  return trail;
}

return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
        <h3>
          檔案資訊 File Properties
        </h3>

        <div className="info-group">

          {/* TITLE */}
          <div className="info-row">
            <strong>標題 Title:</strong>
            <div style={{ marginTop: "0.3rem", marginLeft: "1rem" }}>
              {file.title_id}
              {file.title_zh &&
                file.title_zh !== file.title_id && (
                  <div style={{ opacity: 0.75 }}>
                    {file.title_zh}
                  </div>
                )}
            </div>
          </div>

          <div className="info-row">
            <strong>格式 Format:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {file.mime_type}
            </span>
          </div>

          {/* FOLDER LOCATION */}
          <div className="info-row">
            <strong>所在資料夾 Folder:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {buildBreadcrumb(file.document_folder)
                .map(f => f.name)
                .join(" / ") || "-"}
            </span>
          </div>

          <div className="info-row">
            <strong>檔案大小 File Size:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {formatSize(file.file_size)}
            </span>
          </div>

          <div className="info-row">
            <strong>建立時間 Created:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {formatDate(file.createdAt)}
            </span>
          </div>

          <div className="info-row">
            <strong>更新時間 Updated:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {formatDate(file.updatedAt)}
            </span>
          </div>

          <div className="info-row">
            <strong>建立者 Author:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {file.createdBy?.username || "-"}
            </span>
          </div>

          <div className="info-row">
            <strong>最後編輯 Editor:</strong>
            <span style={{ marginLeft: "0.5rem" }}>
              {file.updatedBy?.username || "-"}
            </span>
          </div>

        </div>

        {/* ===== SHARE BUTTONS (Conditional) ===== */}
        {showShareActions && (
          <div className="dialog-actions">
            <button
              className="icon-btn neutral"
              onClick={() => {
                const link =
                  `${window.location.origin}/filesdirect?document=${file.documentId}`;
                navigator.clipboard.writeText(link);
              }}
            >
              <img src="/icons/link-copy.png" alt="Copy Link" />
            </button>

            <button
              className="icon-btn neutral"
              onClick={() => {
                const link =
                  `${window.location.origin}/filesdirect?document=${file.documentId}`;
                if (navigator.share) {
                  navigator.share({
                    title: file.title_id,
                    url: link,
                  });
                } else {
                  navigator.clipboard.writeText(link);
                }
              }}
            >
              <img src="/icons/share.png" alt="Share" />
            </button>

            <button onClick={onClose} className="btn-secondary">
              關閉 Close
            </button>
          </div>
        )}

        {!showShareActions && (
          <div className="dialog-actions">
            <button onClick={onClose} className="btn-secondary">
              關閉 Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

FileInfoDialog.propTypes = {
  file: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};
